import gql from 'graphql-tag';

// QUERIES

const getTeamsSafeQuery = gql`
  query teamsInAssociation($associationId: ObjectId!) {
    teams: teamsInAssociation(associationId: $associationId) {
      _id
      associationId
      name
      slug
      salesStartDate
      salesEndDate
    }
  }
`;

const getTeamsQuery = gql`
  query teamsInAssociation($associationId: ObjectId!) {
    teams: teamsInAssociation(associationId: $associationId) {
      _id
      associationId
      name
      slug
      adminEmails
      decryptedAdminToken
      useAssociationPaymentInfo
      bankInformation {
        clearingNumber
        accountNumber
        accountOwner
      }
      adminUsers {
        _id
        email
        firstname
        lastname
      }
      adminInvitations {
        sentToEmail
        userIdActivated
      }
      salesStartDate
      salesEndDate
    }
  }
`;

const getTeamQuery = gql`
  query ($teamId: ObjectId!) {
    team: team(teamId: $teamId) {
      _id
      name
      decryptedTeamMemberCreationToken
      associationSlug
      slug
      adminEmails
      useAssociationPaymentInfo
      bankInformation {
        clearingNumber
        accountNumber
        accountOwner
      }
      adminUsers {
        _id
        firstname
        lastname
        email
      }
      adminInvitations {
        sentToEmail
        userIdActivated
      }
      salesStartDate
      salesEndDate
    }
  }
`

const getTeamNameQuery = gql`
  query ($teamId: ObjectId!) {
    name: teamName(teamId: $teamId)
  }
`;

const getTeamBySlug = gql`
  query ($slug: String!, $associationSlug: String!) {
    team: teamBySlug(slug: $slug, associationSlug: $associationSlug) {
      _id
      name
      associationId
      salesStartDate
      salesEndDate
    }
  }
`;

const statOrdersByTeamQuery = gql`
  query ($teamId: ObjectId!, $bookletId: ObjectId, $fromDate: DateTime, $toDate: DateTime) {
    orders: statOrdersByTeam(teamId: $teamId, bookletId: $bookletId, fromDate: $fromDate, toDate: $toDate) {
      #periods {
        #period
        #amount
        #number
      #}
      totalNumber
      #totalAmount
      webshopEarnings
      webshopOrders {
        _id
        paidDate
        completedDate
        totalPrice
      }
    }
  }
`;

const statOrdersByTeamMemberQuery = gql`
  query ($teamMemberId: ObjectId!, $fromDate: DateTime, $toDate: DateTime) {
    orders: statOrdersByTeamMember(teamMemberId: $teamMemberId, fromDate: $fromDate, toDate: $toDate) {
      #periods {
        #period
        #amount
        #number
      #}
      totalNumber
      #totalAmount
    }
  }
`;

const statTeamTopTeamMembersQuery = gql`
  query ($teamId: ObjectId!, $fromDate: DateTime, $toDate: DateTime) {
    teamMembers: statTeamTopTeamMembers(teamId: $teamId, fromDate: $fromDate, toDate: $toDate) {
      teamMembers {
        teamMember {
          _id
          firstname
          lastname
        }
        total
      }
    }
  }
`;



// MUTATIONS

const addTeamMutation = gql`
  mutation(
    $associationId: ObjectId!,
    $name: String!,
    $adminEmails: [String!],
    $salesStartDate: DateTime,
    $salesEndDate: DateTime,
    ) {
    createTeam(
      associationId: $associationId,
      name: $name,
      adminEmails: $adminEmails,
      salesStartDate: $salesStartDate,
      salesEndDate: $salesEndDate,
      ) {
        _id
      }
    }
`;

const updateTeamMutation = gql`
  mutation(
    $_id: ObjectId!
    $name: String
    $adminEmails: [String!]
    $slug: String
    $salesStartDate: DateTime
    $salesEndDate: DateTime
    $useAssociationPaymentInfo: Boolean
    $bankInformation: BankInformationInput
    $paidOutByBooklet: [PaidOutAmountInput!]
    ) {
    updateTeam(
      _id: $_id,
      name: $name,
      adminEmails: $adminEmails,
      slug: $slug,
      salesStartDate: $salesStartDate,
      salesEndDate: $salesEndDate,
      useAssociationPaymentInfo: $useAssociationPaymentInfo,
      bankInformation: $bankInformation,
      paidOutByBooklet: $paidOutByBooklet,
      ) {
        _id
    }
  }
`;

const extendSalesPeriodMutation = gql`
  mutation extendSalesPeriod($teamId: ObjectId!, $extensionToken: String) {
    extendSalesPeriod(teamId: $teamId, extensionToken: $extensionToken) {
      _id
      name
      salesEndDate
    }
  }
`;

const sendTeamSalesThankYouEmailMutation = gql`
  mutation sendTeamSalesThankYouEmail($teamId: ObjectId!) {
    sendTeamSalesThankYouEmail(teamId: $teamId)
  }
`;

export {
  getTeamsSafeQuery,
  getTeamsQuery,
  getTeamQuery,
  getTeamNameQuery,
  getTeamBySlug,
  statOrdersByTeamQuery,
  statOrdersByTeamMemberQuery,
  statTeamTopTeamMembersQuery,
  addTeamMutation,
  updateTeamMutation,
  extendSalesPeriodMutation,
  sendTeamSalesThankYouEmailMutation,
};
